import {
  ArrowLeftRight,
  Building2,
  FileSearch,
  Flag,
  ListChecks,
  ShieldUser,
  Users,
  UserSearch,
  UsersRound,
} from 'lucide-react';

import { getRoutingPath, ROUTES } from '@itp/talent/constants/routingPath';

import { MenuItem } from './asideNavigation';

interface AdminMenuItemsParams {
  isAdmin: boolean;
  isImpersonate: boolean;
}

export const adminMenuItems = ({ isAdmin, isImpersonate }: AdminMenuItemsParams): MenuItem[] => [
  {
    isMainMenu: true,
    label: 'Admin',
  },
  ...(isAdmin
    ? [
        // {
        //   icon: UserSearch,
        //   iconSelected: UserSearch,
        //   label: 'Talent search',
        //   link: getRoutingPath(ROUTES.ADMIN_TALENT_SEARCH),
        // },
        {
          icon: Building2,
          iconSelected: Building2,
          label: 'Companies',
          link: getRoutingPath(ROUTES.ADMIN_COMPANIES),
        },
        {
          icon: FileSearch,
          iconSelected: FileSearch,
          label: 'Job ads',
          link: getRoutingPath(ROUTES.ADMIN_JOB_ADS),
        },
        {
          icon: UsersRound,
          iconSelected: UsersRound,
          label: 'Job applications',
          link: getRoutingPath(ROUTES.ADMIN_JOB_APPLICATIONS),
        },
        {
          icon: Flag,
          iconSelected: Flag,
          label: 'Feature flags',
          link: getRoutingPath(ROUTES.ADMIN_FEATURE_FLAGS),
        },
        {
          icon: ListChecks,
          iconSelected: ListChecks,
          label: 'Quizzes',
          link: getRoutingPath(ROUTES.ADMIN_QUIZZES),
        },
        {
          icon: Users,
          iconSelected: Users,
          label: 'Users',
          link: getRoutingPath(ROUTES.ADMIN_USERS),
        },
      ]
    : []),
];
